import { Request as JSONRequest } from "../helpers/request";
import { defaultProvider } from "../helpers/contracts";

class GlobalController extends JSONRequest {
  constructor() {
    super({ url: import.meta.env.VITE_BACKEND_API_URL });
  }

  // { success, result: { headBlock, trackingService } }: last block indexed by the KoinDX API
  async getStatus() {
    return this.getPrepared("/v2/status");
  }

  async getBlockHead() {
    return defaultProvider.getHeadInfo();
  }
}

export let global = new GlobalController();
